import React from 'react';

import {
    Group, Text,
} from '@mantine/core';

import { PUBLIC_DOMAIN_APP } from '../../../../const';

// TODO: перенести стили в css
const getRowStyles = () => ({
    flexWrap: 'nowrap',
});

const getTextStyles = () => ({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '740px',
});

export default function useColLinkSchema({
    accessor, title, type, defaultData, getUrl, target = '_blank',
}) {
    const colLinkSchema = {
        type,
        accessor,
        title,
        render: ({ row, currentData }) => {
            const url = typeof getUrl === 'function' ? getUrl(row) : row.url;

            return (
                <div>
                    <a href={`${PUBLIC_DOMAIN_APP}${url}`} target={target}>
                        <Group
                            spacing="xs"
                            sx={getRowStyles}
                        >
                            <Text
                                sx={getTextStyles}
                            >
                                {currentData || defaultData}
                            </Text>
                        </Group>
                    </a>
                </div>
            );
        },
    };

    return colLinkSchema;
}
